var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYogaOrDance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 482,
    viewBox: "0 0 220 482",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.593 125.127C124.332 125.127 139.523 109.936 139.523 91.1973C139.523 72.4583 124.332 57.2673 105.593 57.2673C86.8537 57.2673 71.6627 72.4583 71.6627 91.1973C71.6627 109.936 86.8537 125.127 105.593 125.127Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.781 2.18962C115.437 9.15153 173.471 58.8394 173.471 94.6034C173.471 112.495 147.177 142.551 140.047 147.529C135.686 150.579 121.5 150.037 104.357 150.261C93.5403 150.43 72.299 150.074 68.8929 146.668C59.9659 137.741 36.8719 111.522 36.8719 98.3276C36.8719 70.4987 89.1423 5.24014 81.0201 0.187135C73.6465 -4.43542 0.714844 74.8592 0.714844 99.5815C0.714844 137.498 51.6378 193.361 51.6378 193.361C51.6378 193.361 51.2261 269.942 51.2261 277.934C51.2261 346.673 75.1998 482 95.9919 482C108.793 482 97.6014 410.06 97.6014 375.981C97.6014 335.482 105.593 294.983 105.593 294.983C105.593 294.983 169.354 317.197 162.561 324.197C146.616 340.61 103.272 356.536 108.886 364.958C115.961 375.55 179.46 358.988 217.208 329.175C233.022 316.692 153.241 256.842 153.241 256.842C153.241 223.474 153.708 222.688 152.062 193.38C152.062 193.38 206.26 134.26 206.26 100.592C206.26 53.8799 131.101 -8.0661 121.781 2.18962Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYogaOrDance);
export default __webpack_public_path__ + "static/media/yoga_or_dance.d308559d987834f0e41dc736761bbb50.svg";
export { ForwardRef as ReactComponent };